import './button.scss';
import ecommerceStyles from './ecommerce-buttons.module.scss';

import { ButtonHTMLAttributes, DetailedHTMLProps } from 'react';
import classNames from 'classnames';

export const Button = ({
  dataCy,
  ...props
}: { dataCy?: string } & Omit<
  DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>,
  'type'
>) => {
  return <button type="button" data-cy={dataCy} {...props}></button>;
};

export const EcommerceButton = ({
  dataCy,
  className,
  type = 'button',
  buttonStyle = 'primary',
  ...props
}: { dataCy?: string; buttonStyle?: 'primary' | 'secondary' | 'tertiary' } & DetailedHTMLProps<
  ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
>) => {
  return (
    <button
      className={classNames(className, {
        [ecommerceStyles.primary]: buttonStyle === 'primary',
        [ecommerceStyles.secondary]: buttonStyle === 'secondary',
        [ecommerceStyles.tertiary]: buttonStyle === 'tertiary',
      })}
      data-cy={dataCy}
      type={type}
      {...props}
    ></button>
  );
};
